import { Directive, ElementRef, Input } from '@angular/core';
import { SlIdContext } from './sl-id-context';

@Directive({ selector: '[sl-aria-labelledby]' })
export class SlAriaLabelledbyDirective {
  constructor(private el: ElementRef, private ids: SlIdContext) { }

  @Input('sl-aria-labelledby')
  set localIds(value: string) {
    this.setIdRefs('aria-labelledby', value);
    this.el.nativeElement.removeAttribute('sl-aria-labelledby');
  }

  private setIdRefs(attributeName: string, value: string): void {
    if (!value || !value.trim()) {
      this.el.nativeElement.removeAttribute(attributeName);
      return;
    }

    var localIds = value.trim().split(/\s+/);
    var contextualIds: string[] = [];
    var i: number;

    for (i = 0; i < localIds.length; i++) {
      if (localIds[i]) {
        contextualIds.push(this.ids.id(localIds[i]));
      }
    }

    this.el.nativeElement.setAttribute(attributeName, contextualIds.join(' '));
    this.el.nativeElement.removeAttribute('sl-aria-labelledby');
  }
}
